import { FALLBACK_CLIP_TITLE } from '../../../../constants'
import { CreationToolSourceFile } from '../../../../types'
import getUnvalidatedSource from '../../../../utils/get-unvalidated-source'
import { ICapture, ISegment } from '../types'
import Imaging from './imaging'
import { getCropForAspectRatio } from './utils'

const SESSION_STORAGE_KEY = 'SUPERCUT_UPLOAD_DATA'

const processImagingUrl = async (url: string, filename: string = FALLBACK_CLIP_TITLE): Promise<File> => {
    const blob = await fetch(url).then(response => response.blob())
    return new File([blob], filename, {
        type: blob.type,
        lastModified: Date.now(),
    })
}

class Uploader {
    static setUploadSessionData = data => {
        window.sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(data))
    }

    static getUploadSessionData = () => {
        return JSON.parse(window.sessionStorage.getItem(SESSION_STORAGE_KEY) || '{}')
    }

    static clearUploadSessionData = () => {
        Uploader.setUploadSessionData({})
    }

    static getVideoURLs = async (capture: ICapture, segments: ISegment[]) => {
        return Promise.all(
            segments.map(async segment => {
                let url = segment.video_url

                const { captionWatermark, trimmedStartTime, trimmedEndTime, aspectRatio } = segment.editParams

                if (captionWatermark) {
                    const watermarkData = captionWatermark
                    url = await Imaging.burnWatermark(url, watermarkData)
                }

                if (trimmedStartTime > 0 || trimmedEndTime !== segment.duration) {
                    const start = trimmedStartTime
                    const duration = trimmedEndTime - trimmedStartTime
                    url = Imaging.trim(url, start, duration)
                }

                if (aspectRatio !== 'original') {
                    const cropDimensions = getCropForAspectRatio(capture.width, capture.height, aspectRatio)
                    url = Imaging.crop(url, cropDimensions.x, cropDimensions.y, cropDimensions.w, cropDimensions.h)
                }

                return url
            })
        )
    }

    static processURLs = async (urls: string[], capture: ICapture) => {
        const processedSources: CreationToolSourceFile[] = []

        for (let i = 0; i < urls.length; i++) {
            let source: string | File = urls[i]

            if (source.indexOf(`imaging.giphy.com`) > -1) {
                source = await processImagingUrl(source, source)
            }

            let processedFile: CreationToolSourceFile = getUnvalidatedSource(source)

            if (capture.title) {
                processedFile.title = capture.title
            }

            if (capture.upload_metadata?.tags) {
                processedFile.tags = capture.upload_metadata?.tags.split(',')
            }

            if (capture.upload_metadata?.source_url) {
                processedFile.sourceUrl = capture.upload_metadata?.source_url
            }

            if (capture.username) {
                processedFile.username = capture.username
            }

            if (capture.upload_metadata?.rating) {
                processedFile.rating = capture.upload_metadata?.rating
            }

            processedSources.push(processedFile)
        }
        return processedSources
    }
}

export default Uploader
